import './SelectPayMethod.less';
export { default as SelectPayMethodItem } from './SelectPayMethodItem';

export const prefix = 'bm-c-select-pay-method';

export { default } from './SelectPayMethod';
